<template>
<div class="chapter">
<div class="inner_page">
<h1>The Joy Fit Club</h1>
<div class="toc"><p>
<b>Contents</b></p>
<p class="para-style-override-1" style="text-align:left;"><img alt="" src="images/9781118181393-ftoc01.png"/></p>
<nav epub:type="toc" id="toc" xmlns:epub="http://www.idpf.org/2007/ops">
<ol>
<li><a href="#/03_9781118181393flast">Acknowledgments</a></li>
<li><a href="#/04_9781118181393cmp01#a1">Introduction</a></li>
<li><a href="#/04_9781118181393cmp01#a2">Joy’s Winning Weight Loss Rules</a></li>
<li><a href="#/05_9781118181393cmp02">Joy's Fit Superstars</a></li>
<li><span href="#/20_9781118181393cmp17" title="Link target outside of Sample">Joy's 3-Week Meal Plan</span></li>
<li><span href="#/21_9781118181393cmp18" title="Link target outside of Sample">Bonus Recipes from Joy's Kitchen</span></li>
</ol>
</nav>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// toc.vue?58f84ff0